import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
import { useHistory } from "react-router";


const HoppersCafeServicePage = ({ components }) => {
    const history = useHistory()
    const getDataIetm = (component) => {
        return (
            component?.Data?.map((serv, key) => {
                return (
                    <div className="HoppersCafeServicePage-item"
                        key={key}
                        style={{
                            backgroundImage: `linear-gradient(#00000080, #00000080), url(${serv?.background})
                        ` }}
                        onClick={() => {
                            history.push(serv?.href)
                        }}>
                        <div className="HoppersCafeServicePage-item-inner">
                            <div className="HoppersCafeServicePage-item-inner-wrapper">
                                <img className="HoppersCafeServicePage-item-inner-wrapper-ic"
                                    alt=""
                                    src={serv?.icon} />
                                <div
                                    className="HoppersCafeServicePage-item-inner-wrapper-text">
                                    {serv?.header}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeServicePage-item":
                return getDataIetm(component)

            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeServicePage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div >
    )
}
export default HoppersCafeServicePage